import { useEffect, useMemo, useState } from "react";
import { getSiteSelectionKey, sortCommsSites } from "./commsSite";
import type { CommsSite, CommsSortColumn, CommsType, SortOrder } from "./commsSite";

const PAGE_SIZE = 100;
export function useCommsTable(sites: CommsSite[], type: CommsType) {
    const [column, setColumn] = useState<CommsSortColumn>("lastHeartbeatReceived");
    const [order, setOrder] = useState<SortOrder>("desc");
    const [hasAppliedSort, setHasAppliedSort] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedId, setSelectedId] = useState<number | string | null>(null);
    const sorted = useMemo(() => sortCommsSites(sites, type, column, order), [sites, type, column, order]);
    const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
    const page = currentPage > totalPages ? 1 : currentPage;
    const paged = useMemo(() => sorted.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE), [sorted, page]);
    useEffect(() => { if (currentPage > totalPages) setCurrentPage(1); }, [currentPage, totalPages]);
    const selectedSite = paged.find(site => String(getSiteSelectionKey(site)) === String(selectedId)) ?? paged[0] ?? null;
    useEffect(() => { setSelectedId(selectedSite ? getSiteSelectionKey(selectedSite) : null); }, [selectedSite]);
    const sort = (next: CommsSortColumn) => {
        setHasAppliedSort(true);
        setCurrentPage(1);
        setOrder(previous => column === next && previous === "asc" ? "desc" : "asc");
        setColumn(next);
    };
    const reset = () => { setHasAppliedSort(false); setColumn("lastHeartbeatReceived"); setOrder("desc"); setCurrentPage(1); };
    return {
        column, order, hasAppliedSort, page, totalPages, paged, total: sorted.length,
        selectedSite, setSelectedId, setCurrentPage, sort, reset,
    };
}
